// we need to keep track of the currently selected currency's exchange rate to use as a formula reference
// we need to keep track of the currently selected currency to use in the row label multi select

import React, { createContext, useContext } from 'react';
import { AdditionalCurrency } from 'common/types/format';

export interface FundExchangeRateContextType {
  selectedCurrency: AdditionalCurrency | null;
  setSelectedCurrency: React.Dispatch<React.SetStateAction<AdditionalCurrency | null>>;
  exchangeRate: number | null;
  currencyList: AdditionalCurrency[] | undefined,
  standardCurrency: string | undefined,
}

export const FundExchangeRateContext = createContext<FundExchangeRateContextType | undefined>(undefined);

export const useFundExchangeRateContext = () => useContext(FundExchangeRateContext)

